import { HomeComponent } from './home/home.component';
import { LoginFormComponent } from './account/login-form/login-form.component';
import { AboutUsComponent } from './basic-data/about-us/about-us.component';
import { DefaultComponent } from './basic-data/default/default.component';
import { MedicalCenterComponent } from './basic-data/medical-center/medical-center.component';
import { MedicalPlatformComponent } from './basic-data/medical-platform/medical-platform.component';
import { ConsultantComponent } from './basic-data/consultant/consultant.component';
import { TermsAndConditionsComponent } from './basic-data/terms-and-conditions/terms-and-conditions.component';
import { DoctorsComponent } from './basic-data/doctors/doctors.component';
import { DoctorProfileComponent } from './basic-data/doctor-profile/doctor-profile.component';
import { NewsDetailsComponent } from './basic-data/news-details/news-details.component';
import { JoinUsComponent } from './basic-data/join-us/join-us.component';
import { ResearchComponent } from './basic-data/research/research.component';
import { StatisticsComponent } from './basic-data/statistics/statistics.component';
import { ContactUSComponent } from './basic-data/contact-us/contact-us.component';
import { AwarenessComponent } from './basic-data/awareness/awareness.component';
import { PrivacyPolicyComponent } from './basic-data/privacy-policy/privacy-policy.component';
import { UsageAgreementComponent } from './basic-data/usage-agreement/usage-agreement.component';

import { RegistrationFormComponent } from './account/registration-form/registration-form.component';

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './guards/empolyee-registeration.guard';
import { ChangePasswordFormComponent } from './account/change-password-form/change-password-form.component';
import { SendEmailFormComponent } from './account/send-email-form/send-email-form.component';
import { ForgetPasswordFormComponent } from './account/forget-password-form/forget-password-form.component';
import { SendEmailConfirmationComponent } from './account/send-email-confirmation/send-email-confirmation.component';
import { PermissionRoleComponent } from './account/permission-role/permission-role.component';
import { IntroVideosComponent } from './account/intro-videos/intro-videos.component';





const routes: Routes = [
  {path: 'login', component: LoginFormComponent   } ,
   { path: 'register', component: RegistrationFormComponent },
  // {path:'permission-role',component:PermissionRoleComponent},
   { path: 'changePassword', component: ChangePasswordFormComponent },
   { path: 'ForgetPasswordEmail', component: SendEmailFormComponent },
   { path: 'ForgetPassword', component: ForgetPasswordFormComponent },
   { path: 'sendEmailConfiramation', component: SendEmailConfirmationComponent },
   { path: 'AboutUs', component: AboutUsComponent },
   { path: 'Default', component: DefaultComponent },
   { path: 'MedicalCenter', component: MedicalCenterComponent },
   { path: 'MedicalPlatform', component: MedicalPlatformComponent },
   { path: 'Consultant', component: ConsultantComponent },
   { path: 'Consultant', component: ConsultantComponent },
   { path: 'TermsAndConditions', component: TermsAndConditionsComponent },
   { path: 'Doctors', component: DoctorsComponent },
   { path: 'Doctors/:subSpecialityId', component: DoctorsComponent },
   { path: 'DoctorProfile/:doctorId', component: DoctorProfileComponent },
   { path: 'NewsDetails/:newsId', component: NewsDetailsComponent },
   { path: 'JoinUs', component: JoinUsComponent },
   { path: 'Research', component: ResearchComponent },
   { path: 'Statistics', component: StatisticsComponent },
   { path: 'ContactUs', component: ContactUSComponent },
   { path: 'Awareness', component: AwarenessComponent },
   { path: 'PrivacyPolicy', component: PrivacyPolicyComponent },
   { path: 'UsageAgreement', component: UsageAgreementComponent },
   { path: 'intro-videos', component: IntroVideosComponent   } ,

   {path: '', component: DefaultComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes) ],
  exports: [RouterModule]
})
export class AppRoutingModule {

}
